<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400"
      :class="{ 'secondBox-bottom': $route.path === '/question' || $route.path === '/protocol' }">
      <div class="logo">
        <!-- <img
          :src="require('@/page/bienestarricotecnologia/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        /> -->
        <span class="title">MACKALE GROUP PUBLIC COMPANY LIMITED</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">หน้าแรก</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/service' }" class="Li2">
          <router-link to="/service" class="nav-link2">
            <span class="routeText2">บริการของเรา</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/about' }" class="Li3">
          <router-link to="/about" class="nav-link3">
            <span class="routeText3">เกี่ยวกับเรา</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/question' }" class="Li4">
          <router-link to="/question" class="nav-link4">
            <span class="routeText4">คำถามที่พบบ่อย</span>
          </router-link>
          <!-- <a href="https://dit.qvcreditlaverapp.com/Q6V0rC2t/cn7S3ysxy.html?q7vtc6T=qvector_ios" class="nav-link4" target="_blank">
            <span class="routeText4">ข้อตกลงความเป็นส่วนตัว</span>
          </a> -->
        </li>
        <li :class="{ 'active-link': $route.path === '/new' }" class="Li5">
          <router-link to="/new" class="nav-link5">
            <span class="routeText5">ข่าว</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/contact' }" class="Li6">
          <router-link to="/contact" class="nav-link6">
            <span class="routeText6">ร่วมมือกับเรา</span>
          </router-link>
        </li>
        <li class="Li7">
          <a href="https://quick.mackale.com/privacy_policy" class="nav-link7" target="_blank">
            <span class="routeText7">นโยบายความเป็นส่วนตัว</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
  /* height: 90px; */
  position: sticky;
  top: 0;
  z-index: 1000;
}

.secondBox {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  /* height: 90px; */
  /* padding: 0 200px; */
  /* background: #5352DF; */
  /* box-shadow: 0px 3px 12.2px 0 rgba(65, 64, 64, 0.1); */
  /* background-image: url("@/page/bienestarricotecnologia/components/img/NavBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
  box-shadow: 0px 4px 9.4px 0px rgba(0, 0, 0, 0.05);
}

.secondBox-bottom {
  /* box-shadow: 0px 1.5px 0px rgba(54, 53, 56, 1); */
}

.logo {
  background-color: #8A5D3C;
  padding: 30px 0;
  font-weight: bold;
  color: black;
  justify-content: center;
  display: flex;
  width: 100%;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 30px;
}

.title {
  /* width: 500px; */
  font-size: 22px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #FFFFFF;
  /* line-height: 23px; */
  /* padding-left: 17px; */
  /* text-transform: uppercase; */
  height: 24px;
  line-height: 24px;
  /* height: 90px;
  line-height: 90px; */
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5,
.routeText6,
.routeText7,
.routeText8{
  font-size: 18px;
  font-family: SF Pro-Semibold;
  /* font-weight: 400; */
  color: #666666;
  /* opacity: 0.8; */
  /* line-height: 29px; */
  /* text-transform: uppercase; */
}



.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5,
.nav-link6,
.nav-link7,
.nav-link8 {
  text-decoration: none;
  margin: 0 auto;
}

.nav-links {
  background-color: #FFFFFF;
  width: 100%;
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
  /* height: 100%; */
  height: 80px;
  gap: 10px;
}

.nav-links li {
  /* border: 1px solid red; */
  display: flex;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  align-items: center;
  /* padding-left: 4px;
  padding-right: 4px; */
  /* padding: 6px; */
  height: 100%;
  /* line-height: 90px; */
}

.Li1 {
  width: 100px;
}

.Li2 {
  width: 150px;
}

.Li3 {
  width: 150px;
}

.Li4 {
  width: 200px;

}
.Li5 {
  width: 100px;

}
.Li6 {
  width: 200px;

}
.Li7 {
  width: 200px;
}

.Li8 {
  width: 210px;
  /* 这个如果给margin-right底部可能会出现边距的问题 */
}

.active-link {
  /* border-color: #48B46E; */
  background-color: #F5EDEA;
  color: #666666;
  /* border-radius: 8px; */
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5,
.active-link .routeText6,
.active-link .routeText7,
.active-link .routeText8 {
  font-family: Inter-Extra Bold;
  font-weight: bold;
  color: #333333;
  /* opacity: 1; */
}

.active-link .routeText1::after,
.active-link .routeText2::after,
.active-link .routeText3::after,
.active-link .routeText4::after,
.active-link .routeText5::after,
.active-link .routeText6::after,
.active-link .routeText7::after,
.active-link .routeText8::after {
  content: "";
  display: block;
  /* 初始时下划线可见 */
  /* border-bottom: 4px solid #FF8548;  */
  border-radius: 20px;
  /* 调整下划线的长度 */
  /* width: 50%;  */
  transition: width 0s ease-in-out; /* 添加 transition 效果 */
  /* margin-top: 10px; */
}

.title {
  /* border: 1px solid red; */
  /* padding-left: 30px; */
  /* width: 600px */
}

/* .secondBox {
  padding: 0 100px 0 50px;
} */
</style>  /* 这个如果给margin-right底部可能会出现边距的问题 */